import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', py: { xs: 2, md: 3 }, mt: 'auto' }}>
      <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 3 }, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" align="center">
          &copy; 2024 squashpat.com — {t('copyright')} ·{' '}
          <Link to="/impressum" style={{ color: 'inherit' }}>{t('nav.imprint')}</Link>
          {' '}·{' '}
          <Link to="/datenschutz" style={{ color: 'inherit' }}>{t('nav.privacy')}</Link>
        </Typography>
      </Container>
    </Box>
  )
}

export default Footer

